import React from "react";
import SEO from "../components/seo";
import Header from "../components/header/header";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

import charlesSchwab from "../images/charles-schwab.png";
import tdAmeritrade from "../images/td-ameritrade-logo.png";
import luxuryBG from "../images/luxury-real-estate-bg.jpeg";
import lboBG from "../images/lbo-fund-bg.jpeg";

import "swiper/dist/css/swiper.css";
import "../sass/pages/client-login.scss";

class ClientLogin extends React.Component {
  render() {
    return (
      <>
        <SEO title={"Client Login"} />
        <Header />
        <div className="client-login-header">
          <div className="container">
            <h1 className="text-white">Client Login</h1>
          </div>
        </div>
        <div style={{ paddingTop: "7rem" }}>
          <Container>
            <Row className="g-4">
              <Col md={6}>
                <div className="client-box-cta">
                  <div
                    className="client-box-cta-logo"
                    style={{ backgroundImage: `url(${charlesSchwab})` }}
                  />
                  <a
                    className="client-box-cta-title"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://client.schwab.com/Login/SignOn/CustomerCenterLogin.aspx?ReturnUrl=%2f&SessionTimeOut=Y"
                  >
                    Client Center
                  </a>
                </div>
              </Col>
              <Col md={6}>
                <div className="client-box-cta">
                  <div
                    className="client-box-cta-logo"
                    style={{ backgroundImage: `url(${tdAmeritrade})` }}
                  />
                  <a
                    className="client-box-cta-title"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.advisorclient.com/login"
                  >
                    Advisor Center
                  </a>
                </div>
              </Col>
              <Col md={6}>
                <div className="client-box-cta client-box-no-logo">
                  <a
                    className="client-box-cta-title"
                    style={{ fontSize: "1.5rem" }}
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://investors.baystreetcapitalholdings.com/"
                  >
                    Luxury Real Estate Fund
                  </a>
                  <div
                    className="cta-box-bg"
                    style={{ backgroundImage: `url(${luxuryBG})` }}
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="client-box-cta client-box-no-logo">
                  <a
                    className="client-box-cta-title"
                    style={{ fontSize: "1.5rem" }}
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://investors.baystreetcapitalholdings.com/"
                  >
                    LBO Fund
                  </a>
                  <div
                    className="cta-box-bg"
                    style={{ backgroundImage: `url(${lboBG})` }}
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="section_padding home-quote">
          <div className="container">
            <div className="row">
              <div className="qoute-body">
                <div className="col-lg-6">
                  <div className="text-left section-info">
                    <h4 className="mb-3">
                      “It is our core belief that designing a portfolio through
                      the appropriate mix of assets for each unique investor is
                      the key to successful, long-term investing. Selecting fund
                      managers for each asset class is a factor, but
                      meticulously designing the asset allocation is what
                      ultimately determines a portfolio’s failure or success.”
                    </h4>
                    <h6 className="text-dark">
                      -William Huston, Founder, Chief Investment Officer
                    </h6>
                  </div>
                </div>
                <div className="col-md-12 d-lg-none mt-4">
                  <StaticImage
                    placeholder="blurred"
                    layout="constrained"
                    fit="cover"
                    src="../images/william.jpg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ClientLogin;
